import React from "react";
import "./PageFooter.css";

const PageFooter = () => {
  return (
    <>
      <section className="cta-section">
        <div className="cta-section__radar" aria-hidden="true">
          <div className="cta-orbit cta-orbit--1">
            <span />
          </div>
          <div className="cta-orbit cta-orbit--2">
            <span />
          </div>
        </div>
        <div className="cta-section__inner">
          <h2 className="cta-section__title">
            Prêt à développer votre visibilité locale ?
          </h2>
          <p className="cta-section__subtitle">
            Franchises, réseaux multi-établissements, agences, Localranker vous
            accompagne à grande échelle.
          </p>
          <a
            className="cta-section__btn"
            href="https://localranker.fr/demander-demo?utm_source=localranker.tech&utm_medium=footer"
            target="_blank"
            rel="noopener noreferrer"
          >
            Demander une démo
          </a>
        </div>
      </section>

      <footer className="site-footer">
        <div className="site-footer__inner">
          <span className="site-footer__text">
            © {new Date().getFullYear()} Localranker — Logiciel de visibilité
            locale intelligent
          </span>
          <a
            className="site-footer__link"
            href="https://localranker.fr/?utm_source=localranker.tech"
            target="_blank"
            rel="noopener noreferrer"
          >
            localranker.fr
          </a>
        </div>
      </footer>
    </>
  );
};

export default PageFooter;
